/**
 * 权限认证指令
 *
 */

export const auth = {
  inserted(el, binding, vnode) {
    const data = vnode.context.$store.getters["accountStore/getUserInfo"]['authorizedKey'] || [];
    const _parentElement = el.parentNode;
    if (data.includes(binding.value)) {
      
    }else{
        _parentElement.removeChild(el);// 没有权限就删掉节点
    }
  }
}

/**
 * 数字框输入指令:禁止输入小数
 */
export const decimal = {
  inserted(el) {
    el.addEventListener('keypress', function (event) {
      const charCode = (event.which)? event.which : event.keyCode;
      if (charCode === 46) {
        event.preventDefault();
      }
    });
  }
}
